import {useSelector} from "react-redux";

export const useSelectPageSize = () => {
  return useSelector(({chats}) => chats.pageSize);
}
